import lodash from "lodash";
import Row from "./Row";
import Meta from "./Meta";

export default class Body {

    constructor(options) {   

        options = options || {};
        
        this.rows = [];
        this.meta = null;
        
        if( options.hasOwnProperty('rows') ) {
            this.addRows(options.rows);

            if( options.hasOwnProperty('meta') ) {
                this.setMeta(meta);
            }

        } else {
            this.addRows(options);
        };
    }

    setMeta(meta) {

        if(meta && ! ( meta instanceof Meta ) ) {
            meta = new Meta(meta);
        };

        this.meta = meta;
        return this;
    }

    addRow(row) {

        if( ! ( row instanceof Row ) ) {
            row = new Row(row);
        };

        this.rows.push(row);
        return this;
    }

    addRows(rows) {
        for( let index in rows ) {
            this.addRow(rows[index]);
        }
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Body.js